import {
    getData,
    postData,
} from './Services'

export const getArtDepositoPanel = async (artId,depoId, ramoId ,rubroId,subrubroId,marcaId, esDestacado, conExistencia, page, perPage) => {
    let queryParams = [];
    if (artId) {
        queryParams.push(`ade_art_id=${encodeURIComponent(artId || '')}`);
    }
    if (depoId) {
        queryParams.push(`ade_depo_id=${encodeURIComponent(depoId || '')}`);
    }
    if (ramoId) {
        queryParams.push(`ade_ram_id=${encodeURIComponent(ramoId || '')}`);
    }
    if (rubroId) {
        queryParams.push(`ade_rub_id=${encodeURIComponent(rubroId || '')}`);
    }
    if (subrubroId) {
        queryParams.push(`ade_subr_id=${encodeURIComponent(subrubroId || '')}`);
    }
    if (marcaId) {
        queryParams.push(`ade_mar_id=${encodeURIComponent(marcaId || '')}`);
    }
    if (esDestacado !== undefined) {
        queryParams.push(`ade_destacado=${encodeURIComponent(esDestacado || '')}`);
    }
    if (conExistencia !== undefined) {
        queryParams.push(`ade_con_existencia=${encodeURIComponent(conExistencia || '')}`);
    } 
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/artDepositos/articulos_depo_filtros", queryString);
};
  
export const postRealizarInventario = async (body) => {
  const res = await postData('/artDepositos/realizar_inventario', body)
  return res
}
